import fetch, { fetchConfig } from '@/hooks/fetch';
import { states } from '@/constants/lifecycle';
import paging, { pagingConfig, pagingHookConfig } from '@/hooks/paging';
import actions, { imageActions } from '../constants';

export default {
  useFetchImages: ({ items }, readStatus) => fetch.useFetchDispatch(
    imageActions.FETCH_IMAGES,
    readStatus.some((r) => (r === states.NONE)) ? states.NONE : states.SUCCESS,
    { items },
    fetchConfig([readStatus, items]),
  ),
  useFetchThemes: ({ category }, readStatus, config = pagingHookConfig()) => paging.useDispatchByCategory(
    actions.FETCH_THEMES,
    category,
    readStatus,
    config,
  ),
  useFetchRibbonThemes: (readStatus) => paging.useDispatchByCategory(
    actions.FETCH_THEMES,
    'ribbon',
    readStatus,
    { ...pagingHookConfig(), ...pagingConfig(10000) },
  ),
};
